import UserWeeklyLogStore from './appStores/user-weekly-log-store';
import UserWeekStore from './appStores/week-store';

class RootStore {
    userWeeklyLogStore = new UserWeeklyLogStore();
    userWeekStore = new UserWeekStore();
}

export default RootStore
